module.exports = __webpack_public_path__ + "img/_icon_edit.041d42dd.svg";